import pdfMake from 'pdfmake/build/pdfmake.js';
import moment from 'moment';

const makePDF = async (data) => {

    //console.log(data);

    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        }
    };

    const user = JSON.parse(sessionStorage.getItem('usuario'));
    const fecha = moment(new Date()).format('ll');
    const hora = moment(new Date()).format('LTS');


    let services = [];

    services.push([{ text: 'Codigo ', bold: true, style: 'textStyle' }, { text: 'Descripcion del Servicio', bold: true, style: 'textStyle' }, { text: 'Cantidad', bold: true, style: 'textStyle' }, { text: 'Observación', bold: true, style: 'textStyle' }]);

    for (let obj of data.services) {
        services.push([{ text: obj.codigo, style: 'textStyle' }, { text: obj.nombre, style: 'textStyle' }, '', ''])
    }

    const header = {
        margin: [40, 10, 0, 0],
        layout: 'noBorders',
        table: {
            widths: ['*', '*'],
            body: [
                [{
                    image: await getBase64ImageFromURL(data.urlLogo),
                    fit: [100, 40],
                },
                { text: data.profile.nombre + '\n  NIT' + data.profile.nit + '\n Dirección: ' + data.profile.direccion.direccion + ' Teléfono:' + data.profile.telefono1, style: 'head' }],
            ]
        },
    };

    let urlFirma = '';
    let urlFirma2 = '';
    //Firma del Doctor
    try
    {
        let urlServe = data.urlDoctor;
        let test = fetch(urlServe)
            .then(response => {
                if (response.status === 500 || response.status === 404) {
                    return false;
                } else {
                    return true;
                }
            });
    
        let isImg = await test;
    
        if (isImg) {
            urlFirma = urlServe;
        } else {
            urlFirma = 'https://i.postimg.cc/cCFjW8g1/prueba.png';
        }
    }
    catch (e) {
        urlFirma = 'https://i.postimg.cc/cCFjW8g1/prueba.png';
    }

    //Firma del Tecnologo
    try
    {
        let urlServe2 = data.urlTech;

        let test2 = fetch(urlServe2)
            .then(response => {
                if (response.status === 500 || response.status === 404) {
                    return false;
                } else {
                    return true;
                }
            });
    
        let isImg2 = await test2;
    
        if (isImg2) {
            urlFirma2 = urlServe2;
        } else {
            urlFirma2 = 'https://i.postimg.cc/cCFjW8g1/prueba.png';
        }
    }
    catch (e) {
        urlFirma2 = 'https://i.postimg.cc/cCFjW8g1/prueba.png';
    }

    const documentDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        header: header,
        content: [
            {
                // auto-sized columns have their widths based on their content                                       
                margin: [0, 20, 0, 0],
                layout: {
                    defaultBorder: false,
                },
                table: {
                    widths: ['*', 180, '*', 80, '*', 60],
                    body: [
                        [
                            { text: 'Nombre ', bold: true, style: 'textStyle', border: [true, true, false, false] },
                            { text: data.fullname, style: 'textStyle', border: [false, true, false, false] },
                            { text: 'Identificación', bold: true, style: 'textStyle', border: [false, true, false, false] },
                            { text: data.documentNumber, style: 'textStyle', border: [false, true, false, false] },
                            { text: 'Tipo', bold: true, style: 'textStyle', border: [false, true, false, false] },
                            { text: data.typeDocument, style: 'textStyle', border: [false, true, true, false] }
                        ],
                        [
                            { text: 'Fecha de Nacimiento ', bold: true, style: 'textStyle', border: [true, false, false, false] },
                            { text: data.birthday, style: 'textStyle' },
                            { text: 'Edad ', bold: true, style: 'textStyle' },
                            { text: data.age, style: 'textStyle' },
                            { text: 'Genero', bold: true, style: 'textStyle' },
                            { text: data.gender, style: 'textStyle', border: [false, false, true, false] },
                        ],
                        [
                            { text: 'Dirección ', bold: true, style: 'textStyle', border: [true, false, false, false] },
                            { text: data.address, style: 'textStyle' },
                            { text: 'Municipio ', bold: true, style: 'textStyle' },
                            { text: data.city, style: 'textStyle' },
                            { text: 'Teléfono ', bold: true, style: 'textStyle', },
                            { text: data.telephone, style: 'textStyle', border: [false, false, true, false] },

                        ],
                        [
                            { text: 'EPS ', bold: true, style: 'textStyle', border: [true, false, false, true] },
                            { text: data.third.nit + ' ' + data.third.nombre, style: 'textStyle', border: [false, false, false, true] },
                            { text: 'Regimen ', bold: true, style: 'textStyle', border: [false, false, false, true] },
                            { text: data.regime, style: 'textStyle', border: [false, false, false, true] },
                            { text: ' ', bold: true, style: 'textStyle', border: [false, false, false, true] },
                            { text: '', style: 'textStyle', border: [false, false, true, true] }
                        ],
                    ]
                },
            },
            {
                // auto-sized columns have their widths based on their content                                       
                margin: [0, 5, 0, 10],
                layout: 'headerLineOnly',
                table: {
                    headerRows: 1,
                    widths: [40, 250, 50, '*'],
                    body: services
                },
            },
            {
                margin: [0, 5, 0, 5],
                text: 'ANTECEDENTES ', style: 'tableheader'
            },
            {
                margin: [0, 0, 0, 5],
                text: data.history, style: 'textStyle'
            },
            {
                margin: [0, 5, 0, 5],
                text: 'TÉCNICA ', style: 'tableheader'
            },
            {
                margin: [0, 0, 0, 5],
                text: data.tecnic, style: 'textStyle'
            },
            {
                margin: [0, 5, 0, 5],
                text: 'DESCRIPCIÓN ', style: 'tableheader'
            },
            {
                margin: [0, 0, 0, 10],
                text: data.description, style: 'textStyle'
            },
            {
                margin: [0, 5, 0, 5],
                text: 'OPINIÓN ', style: 'tableheader'
            },
            {
                margin: [0, 0, 0, 5],
                text: data.opinion, style: 'textStyle'
            },
            {
                margin: [0, 5, 0, 5],
                text: 'OBSERVACIÓN ', style: 'tableheader'
            },
            {
                margin: [0, 0, 0, 5],
                text: data.observation, style: 'textStyle'
            },
            {
                margin: [0, 5, 0, 5],
                text: 'NOTA ', style: 'tableheader'
            },
            {
                margin: [0, 0, 0, 5],
                text: data.note, style: 'textStyle'
            },
            {
                margin: [0, 30, 0, 5],
                text: 'HECHO POR: ' + user.nombre + '\n FECHA: ' + fecha + ' \n HORA: ' + hora, style: 'textStyle'
            },
            {
                margin: [40, 10, 0, 0],
                layout: 'noBorders',
                table: {
                    widths: ['*', '*'],
                    body: [
                        [
                            {
                                margin: [0, 30, 0, 0],
                                layout: 'headerLineOnly',
                                table: {
                                    widths: [100],
                                    headerRows: 1,
                                    body: [
                                        [{
                                            image: await getBase64ImageFromURL(urlFirma),
                                            fit: [80, 80],
                                        },],
                                        [{ text: 'Profesional', style: 'signature', }],
                                        [{ text:   data.fullnameDoctor, style: 'signature', }]
                                    ]
                                },
                            },
                            {
                                margin: [100, 30, 0, 0],
                                layout: 'headerLineOnly',
                                table: {
                                    widths: [100],
                                    headerRows: 1,
                                    body: [
                                        [{
                                            image: await getBase64ImageFromURL(urlFirma2    ),
                                            fit: [80, 80],
                                        },],
                                        [{ text: 'Tecnologo', style: 'signature', }],
                                        [{ text:   data.fullnameTech, style: 'signature', }]
                                    ]
                                },
                            }
                        ],
                    ]
                },
            },
            /*{
                // auto-sized columns have their widths based on their content                                       
                margin: [0, 30, 0, 0],
                layout: 'headerLineOnly',
                table: {
                    widths: [100],
                    headerRows: 1,
                    body: [
                        [{                           
                            image: await getBase64ImageFromURL(urlFirma),
                            fit: [80, 80],
                        },],
                        [{ text: 'Profesional', style: 'signature', }],

                    ]
                },
            },*/
        ],
        styles: {
            head: {
                fontSize: 6,
                bold: true,
                alignment: 'left',
                font: 'OpenSans'
            },
            tableheader: {
                fontSize: 8,
                bold: true,
                font: 'OpenSans'
            },
            textStyle: {
                fontSize: 7,
                font: 'OpenSans'
            },
            signature: {
                fontSize: 8,
                alignment: 'center',
                bold: true,
                font: 'OpenSans'
            },
            foter: {
                margin: 10,
                fontSize: 6,
                font: 'OpenSans'
            },
        }
    };

    //pdfMake.createPdf(documentDefinition).open();
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
        document.getElementById('pdfV').src = outDoc;
    });


}


function getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

export default makePDF;